@if (!isTeaserBet) {
    @for (slip of succeededSlips; track slip) {
        <bs-digital-result-succeeded-slip
            [slip]="slip"
            [oddsDisplayFormat]="oddsDisplayFormat"
            [possibleWinningTitle]="possibleWinningTitle"
            [tokenPayoutSummary]="getSlipTokenPayoutSummary(slip)" />
    }
} @else {
    @if (teasedPoints !== undefined) {
        @for (slip of succeededSlips; track slip) {
            <bs-digital-result-succeeded-teaser-slip [slip]="slip" [oddsDisplayFormat]="oddsDisplayFormat" [teasedPoints]="teasedPoints" />
        }
    }
}
